import { useEffect, useState } from "react";
import { api } from "../api";
import { Link } from "../ui/ScopedLink";
import { ErrorState } from "../ui/State";
export function FinanceYearEnd({
  building,
}: {
  building?: { id: string; name: string } | undefined;
}) {
  const [page, setPage] = useState(1),
    [data, setData] = useState<any>(),
    [error, setError] = useState<unknown>();
  useEffect(() => {
    setPage(1);
  }, [building?.id]);
  useEffect(() => {
    const c = new AbortController();
    setData(undefined);
    setError(undefined);
    void api<any>(
      `/api/finance/operations/year-end?page=${page}${building ? "&building=" + building.id : ""}`,
      { signal: c.signal },
    )
      .then((r) => {
        if (!c.signal.aborted) setData(r);
      })
      .catch((e) => {
        if (!c.signal.aborted) setError(e);
      });
    return () => c.abort();
  }, [building?.id, page]);
  return (
    <section className="panel">
      <h2>Year-end accounts</h2>
      <p>
        Target: four months after year-end. At risk from three months; deadline
        six months. Every ended period is included.
      </p>
      {Boolean(error) && <ErrorState error={error} />}
      <p>
        {data
          ? `${data.total} periods · page ${page}`
          : "Loading year-end accounts…"}
      </p>
      {data?.rows.map((r: any) => (
        <article className="summary-row" key={r.id}>
          <div>
            <strong>
              {r.building_name} · {r.schedule_name} · {r.label}
            </strong>
            <p>
              {r.check.state}: {r.check.detail}
            </p>
            <Link
              to={`/finance/operations?view=reports&building=${r.development_id}&period=${r.id}`}
            >
              Review period
            </Link>
          </div>
        </article>
      ))}
      <div className="actions">
        <button disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
          Previous periods
        </button>
        <button disabled={!data?.hasMore} onClick={() => setPage((p) => p + 1)}>
          Next periods
        </button>
      </div>
    </section>
  );
}
